import dayjs from 'dayjs';
import { isUnary } from 'src/graphql/entities/custom-view/custom-view-config/operators';
import {
  CustomViewFormConditionItem,
  UIType,
} from 'src/graphql/entities/custom-view/custom-view.types';

type LabelOption = { value: unknown; label?: string };

export const formatRuleDate = (value: unknown): string => {
  const raw = String(value ?? '');
  return isNaN(Number(raw)) && !isNaN(new Date(raw).getTime())
    ? dayjs(raw).format('M/D/YY')
    : raw;
};

export const resolveOptionLabel = (
  item: { value: unknown; label?: string },
  options?: readonly LabelOption[],
): string =>
  options?.find((option) => String(option.value) === String(item.value))?.label ??
  item.label ??
  '';

export const ruleValueLabels = (
  rule: CustomViewFormConditionItem,
  options: readonly LabelOption[],
): string[] => {
  if (isUnary(rule.operator)) return [];

  const { value } = rule;

  if (Array.isArray(value)) return value.map((item) => resolveOptionLabel(item, options));
  if (value && typeof value === 'object') {
    return [resolveOptionLabel(value as LabelOption, options)];
  }
  if (typeof value === 'boolean') return [value ? 'True' : 'False'];
  if (typeof value === 'string' && value) {
    return [rule.field?.uiType === UIType.Date ? formatRuleDate(value) : value];
  }

  return [];
};

export const formatConditionValue = (
  condition: CustomViewFormConditionItem,
  options?: readonly LabelOption[],
): string => {
  const { field, value } = condition;

  if (Array.isArray(value)) {
    const labels = value.map((item) => resolveOptionLabel(item, options));

    if (labels.length > 2) {
      return `${labels.length} ${field?.pluralLabel ?? field?.label}`;
    }
    return labels.join(', ');
  }

  const primitive = (value as { value: string })?.value ?? value ?? '';

  return field?.uiType === UIType.Date ? formatRuleDate(primitive) : String(primitive);
};
